import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { GbNotificationService, SnackBarType } from 'libs/shared/utils/notification/src'
import { GbOfflineSnackBarComponent } from 'libs/shared/utils/notification/src/lib/components/gb-offline-snack-bar/gb-offline-snack-bar.component'
import { GbOnlineStatusService } from 'libs/shared/utils/services/src/lib/gb-online-status/gb-online-status.service'
import { Observable, throwError } from 'rxjs'
import { catchError, take, tap } from 'rxjs/operators'
import { MaintenanceConstants } from 'libs/shared/maintenance/src/lib/maintenance.constants'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private snackBarLock = false

  get isShowingOfflineSnackBar(): boolean {
    return this.notificationService.isSnackBarOpen(SnackBarType.Component)
  }

  constructor(
    private notificationService: GbNotificationService,
    private onlineStatusService: GbOnlineStatusService,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (this.isShowingOfflineSnackBar && event instanceof HttpResponse && event.status !== 0) {
          this.dismissOfflineSnackBarIfOnline()
        }
      }),
      catchError((error: HttpErrorResponse) => this.handleError(error)),
    )
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 503) {
      this.redirectToMaintenance()
    } else if (error.status === 500) {
      this.notificationService.error('SHARED.ERROR.SERVER_500')
    } else if (error.status === 0 && !this.isShowingOfflineSnackBar && !this.snackBarLock) {
      this.openOfflineSnackBarIfOffline()
    }
    return throwError(() => error)
  }

  private openOfflineSnackBarIfOffline(): void {
    this.snackBarLock = true // prevent multiple snackbars showing
    this.onlineStatusService.isOnline$.pipe(take(1)).subscribe((isOnline) => {
      if (!isOnline) {
        this.notificationService.snackBarComponentOpen(GbOfflineSnackBarComponent)
      }
      this.snackBarLock = false
    })
  }

  private dismissOfflineSnackBarIfOnline(): void {
    this.onlineStatusService.isOnline$.pipe(take(1)).subscribe((isOnline) => {
      if (isOnline) {
        this.notificationService.dismissSnackBar()
      }
    })
  }

  private redirectToMaintenance(): void {
    this.router.navigate([MaintenanceConstants.UNDER_SCHEDULED_MAINTENANCE])
  }
}
